import { render, staticRenderFns } from "./UserDeletion.vue?vue&type=template&id=7774a804&scoped=true"
import script from "./UserDeletion.vue?vue&type=script&lang=js"
export * from "./UserDeletion.vue?vue&type=script&lang=js"
import style0 from "./UserDeletion.vue?vue&type=style&index=0&id=7774a804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774a804",
  null
  
)

export default component.exports